const sp = {
    "Bem-vindo à Assembleia Nacional":"Bienvenidos a la Asamblea Nacional",
    "Continuar":"Continuar",
    "Escolha seu Idioma":"Seleccione su idioma",
    "O Palácio da Assembleia Nacional":"El Palacio de la Asamblea Nacional",
    "História da Assembleia":"História de la Asamblea",
    "Galeria":"Galería",
    "Quiz":"Quiz",
    "Símbolos":"Simbolos",
    "Visita Virtual":"Visita Virtual",
    "Constituição":"Constitución",
    "Teste seus conhecimentos acerca da Assembleia, Parlamento, Constituição e a República":"Pon a prueba tus conocimientos sobre la Asamblea, el Parlamento, la Constitución y la República",
    "Modo":"Modo",
    "Jogar":"Jugar",
    "15 segundos":"15 segundos",
    "Clássico":"Clásico",
    "sem registros":"no hay registros",
    "sair":"salir",
    "pontos":"puntos",
    "Tema":"Tema",
    "Parabens acertaste todas as nossas questões":"Felicitaciones, tiene todas nuestras preguntas correctas",
    "Tempo esgotado":"Tiempo agotado",
    "Resposta errada":"Respuesta incorrecta",
    "Fim do Quiz":"Fin de la prueba",
    "Total de Pontos":"Total de Puntos",
    "Novo Record":"Nuevo Record",
    "seu nome":"su nombre",
    "salvar":"guardar",
    "responder novamente":"responde de nuevo",
    "lugar":"lugar",
    "Por favor degite seu nome":"Por favor, escriba su nombre",
    "Atuais":"Actual",
    "Antigos":"Antiguo",
    "Autor":"Autor",
    "Compositor":"Compositor",
    "Este browser não suporta audio":"Este navegador no acepta audio",
    "letra":"letra",
    "Título":"Título",
    "descrição":"descripción",
    "Bandeira":"Bandera",
    "Hino":"Himno",
    "Armas":"Escudo de armas",
    "Bandeira (1975-1992)":"Bandera (1975-1992)",
    "Hino (1975-1992)":"Himno (1975-1992)",
    "Armas (1975-1992)":"Escudo de armas (1975-1992)",
    "Constituição da República":"Constitución de la República",
    "fotos":"fotos",
    "Carregando":"Cargando",
    "procurar por artigos":"buscar artículos",
    "procurar":"buscar",
    "Nenhum resultado encontrado":"Ningún resultado encontrado",
    "voltar":"volver",
    "Por favor degite um valor válido":"Por favor ingrese una cifra válida"
}

export default sp;